import React, { useEffect, useState } from "react";
import "./icon.css";

// Icon component props interface
export interface IconProps {
  name: string;
  size?: "small" | "medium" | "large";
  className?: string;
}

// SVG cache for better performance
const svgCache = new Map<string, string>();

const Icon: React.FC<IconProps> = ({ name, size = "medium", className = "" }) => {
  const [svgContent, setSvgContent] = useState<string>("");

  useEffect(() => {
    let isMounted = true;

    // Check cache first
    if (svgCache.has(name)) {
      setSvgContent(svgCache.get(name) || "");
      return;
    }

    // Fetch and cache
    fetch(`/icons/ic-${name}.svg`)
      .then((response: Response) => {
        if (!response.ok) throw new Error("Icon not found");
        return response.text();
      })
      .then((data: string) => {
        const svgElement = data.match(/<svg[^>]*>[\s\S]*?<\/svg>/i)?.[0] || "";
        svgCache.set(name, svgElement);
        if (isMounted) setSvgContent(svgElement);
      })
      .catch((error: Error) => {
        console.error(`Error loading icon: ${name}`, error);
        if (isMounted) setSvgContent(""); // Or set a fallback SVG
      });

    return () => {
      isMounted = false; // Prevent state update on unmounted component
    };
  }, [name]);

  return (
    <div
      className={`icon icon--${size} ${className}`}
      dangerouslySetInnerHTML={{ __html: svgContent }}
      role="img"
      aria-label={`${name} icon`}
    />
  );
};

export default Icon;